// src/constants/difficulties.js
export const difficulties = {
    Easy: '이지',
    Normal: '노말',
    Hard: '하드',
    Chaos: '카오스',
    Extreme: '익스트림',
  };
  